import { lazyLoad } from 'app/utils/loadable';

export const Accruals = lazyLoad(
  () => import('./accruals'),
  (module) => module.Accruals
);
